import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { stripUnit } from 'polished'

import fluidRange from '../../utils/fluidRange'
import { ColorDeterminer, WidthContainer } from '../../utils/helpers.styles'

/**
 * @param {object} spacing
 * @param {'Small'|'Medium'|'Large'} [key='Large']
 * @returns {{mobile: string, desktop: string}}
 */
export function getSectionPadding(spacing, key = 'Large') {
  const sizes = {
    Large: {
      mobile: spacing?.lg,
      desktop: spacing?.max,
    },
    Medium: {
      mobile: spacing?.md,
      desktop: spacing?.xl,
    },
    Small: {
      mobile: spacing?.md,
      desktop: spacing?.md,
    },
  }

  return sizes[key] || sizes.Large
}

export const Section = styled.section(
  WidthContainer,
  ColorDeterminer,
  ({ theme, alignMainContent, topPadding, bottomPadding }) => {
    const tp = getSectionPadding(theme?.spacing, topPadding)
    const bp = getSectionPadding(theme?.spacing, bottomPadding)
    const amc =
      alignMainContent?.toLowerCase() === 'left' ? 'flex-start' : 'center'

    return css`
      ${fluidRange('padding-top', [
        stripUnit(tp?.mobile),
        stripUnit(tp?.desktop),
      ])};

      ${fluidRange('padding-bottom', [
        stripUnit(bp?.mobile),
        stripUnit(bp?.desktop),
      ])};

      position: relative;

      .content {
        > {
          text-align: ${amc};
        }

        &.variable-content {
          margin-left: ${alignMainContent?.toLowerCase() === 'left'
            ? 0
            : 'auto'};
        }
      }

      .leshen-column-wrapper {
        .content {
          margin-left: unset;
        }
      }

      &.leshen-mega-form-wrapper.is-inside-modal {
        padding: 0;

        .leshen-mega-form {
          width: 100%;
        }
      }
    `
  }
)
